module.exports = __webpack_public_path__ + "img/amex-large.bb79772c.svg";